import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import {Card, Col, Table, Button, Modal, Spin} from 'antd';

import Search from './Search';

import { status, client, kmPerDay, alarms, dtcs, battery, goToCarview, dataLead, kmLead, fidelity, daysToFutureM, carStatus } from './Columns';

import './Leads.css';

@withRouter
@inject('translationsStore', 'commonStore', 'leadsStore', 'filterStore')
@observer
class Leads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: []
    };

    const { translationsStore, commonStore } = this.props;

    this.columns = [
      status,
      /* { title: 'W', dataIndex: 'weight', width: '100px' }, //only for debug */
      /* { title: 'I', dataIndex: 'id', width: '100px' }, //only for debug */
      fidelity,
      client(translationsStore),
      kmPerDay(translationsStore),
      {
        title: translationsStore.translate('lead.table.column.car'),
        dataIndex: 'car',
        render: (text, record) => record.car.make.descrizione + ' ' + record.car.model.descrizione
      },
      { width: '70px', title: translationsStore.translate('lead.table.column.plate'), dataIndex: 'car.plate' },
      carStatus(translationsStore),
      battery(translationsStore),
      alarms(translationsStore),
      dtcs(translationsStore, commonStore),
      dataLead(translationsStore),
      kmLead(translationsStore),
      daysToFutureM(translationsStore),
      /* lastComm(translationsStore), */
      { width: '35px', align: 'center', title: translationsStore.translate('lead.table.column.crash'), dataIndex: 'crash', render: (value, record) => <div>{record.withCrash === true ? translationsStore.translate('lead.table.crashPotential') : '—'}</div> },
      goToCarview(props)
    ];

    this.defaultFilterStorePage = 'leads';
  }

  componentWillMount() {
    const { filterStore } = this.props;
    filterStore.setupPage(this.defaultFilterStorePage);
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    const { filterStore } = this.props;
    filterStore.switchToPage(this.defaultFilterStorePage);
  }

  suspend = () => {
    const { translationsStore, leadsStore } = this.props;
    Modal.confirm({
      title: `${translationsStore.translate('lead.suspend.confirm.title')} (${this.state.selectedRowKeys.length})`,
      onOk: () => {
        leadsStore.suspend(this.state.selectedRowKeys).then(() => {
          this.setState({ selectedRowKeys: [] });
        });
      },
      onCancel: () => {
        this.setState({ selectedRowKeys: [] });
      }
    });
  };

  update = () => {
    this.props.leadsStore.load();
  };

  resetFilter = () => {
    this.props.filterStore.reset();
  };

  render() {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: selectedRowKeys => {
        this.setState({ selectedRowKeys });
      }
    };
    const { translationsStore } = this.props;
    return (
      <Card className="Leads" style={{ ...this.props.style }} bordered={false} id="Leads">
        {!this.props.loading &&
        <Col style={{ paddingBottom: '25px', float: 'none' }} className="actions">
          <div className="suspendContainer">
            <Button type="primary" className="suspend" disabled={selectedRowKeys.length === 0} onClick={this.suspend}>
              {translationsStore.translate('lead.suspend.button')}
            </Button>
          </div>
          <Search />
          <div className="resetContainer">
            <Button type="primary" className="reset" onClick={this.resetFilter}>
              {translationsStore.translate('lead.reset')}
            </Button>
          </div>
          <div className="updateContainer">
            <Button type="primary" className="update" onClick={this.update}>
              {translationsStore.translate('lead.update')}
            </Button>
          </div>
        </Col>}
        <Col>
          {this.props.loading &&
            <div style={{display:"flex", flexDirection:"column", alignContent:"center"}}>
              <Spin tip={translationsStore.translate('loading.message')} size={"large"}>
              </Spin>
            </div>
          }
          {!this.props.loading &&
            <Table pagination={false} rowSelection={rowSelection} columns={this.columns} dataSource={this.props.data} rowKey={record => record.id} />
          }
        </Col>
      </Card>
    );
  }
}

export default Leads;
